import request from '@apps-common/js-client/api/request';

import {trackEvent} from '@explorer/analytics';
import {toolsObjectToGroupType} from '@explorer/components/dialogs/orders-dialog/group-items';
import {ORDERS_ENDPOINT} from '@explorer/config';

export const createOrderRequest = async orders => {
  const results = [];
  for (const order of orders) {
    const result = await request
      .post(ORDERS_ENDPOINT, {
        ...order,
        order_type: 'partial',
      })
      .then(res => {
        const {clip} = order.tools?.find(tool => 'clip' in tool) ?? {};
        trackEvent('Order Placed Successfully', {
          orderName: order.name,
          itemType: order.products[0].item_type,
          productBundle: order.products[0].product_bundle,
          compositeType: toolsObjectToGroupType(order.tools),
          featureReference:
            clip?.aoi.type === 'ref' ? clip.aoi.content : undefined,
        });

        return res.data;
      })
      .catch(err => {
        return {
          ...order,
          error: err,
        };
      });

    // This is needed in order to avoid 429s from API
    // Promise.all would have the same issue and would need a similar
    // buffer between requests
    await setTimeout(500);

    results.push(result);
  }

  return results;
};

export const getOrders = url =>
  request
    .get(url || ORDERS_ENDPOINT, {
      params: {
        source_type: 'scenes',
      },
    })
    .then(response => response.data);
